import { render, staticRenderFns } from "./plugins.vue?vue&type=template&id=678d2f9c&scoped=true&"
import script from "./plugins.vue?vue&type=script&lang=js&"
export * from "./plugins.vue?vue&type=script&lang=js&"
import style0 from "./plugins.vue?vue&type=style&index=0&id=678d2f9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d2f9c",
  null
  
)

export default component.exports